import { Card } from "~/screens/Hub/Home/components";
import { ATHENA_PORTAL } from "~/screens/Hub/shared/sharedUrls";
import { Button } from "~/shared";
import { customIcons } from "~/ui";

export const MessageProvider = () => (
  <Card title="Message my clinician or coach" className="items-start space-y-4">
    <div className="w-full space-y-4 text-left">
      <p className="text-indigo">
        Questions about clinical care or your wellness plan? Send a member of
        your care team a secure message in the patient portal, and we'll get
        back to you within 2-3 business days.
      </p>

      <Button className="px-6 py-3 font-medium" variant="outline" asChild>
        <a
          href={ATHENA_PORTAL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2"
        >
          Go to my portal
          <customIcons.ArrowUpRightIcon className="size-4" />
        </a>
      </Button>
    </div>
  </Card>
);
